/* istanbul ignore file */

import type { ReactElement } from 'react';
import React from 'react';

import * as styles from './FooterPromo.styles';

interface FooterPromoProps {
  children: ReactElement | ReactElement[];
  intro: string;
  title: string;
}

export const FooterPromo = ({ children, intro, title }: FooterPromoProps) => (
  <div css={styles.container}>
    <h3 css={styles.title}>{title}</h3>
    <p css={styles.intro}>{intro}</p>
    {children}
  </div>
);
